export default "__VITE_ASSET__Pu9Q7tif__"